// extracted by mini-css-extract-plugin
export default {"carouselSection":"Trending_carouselSection__ByhGh","wrapper":"Trending_wrapper__MKq4n","carouselTitle":"Trending_carouselTitle__LOHpK"};